module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_9.29e0ada3.png";